module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/redirect/redirect.component.css
// module id = ./src/app/pages/redirect/redirect.component.css
// module chunks = main